<template>
  <div
    v-if="views.length"
    class="flex items-center shrink-0"
    data-test="user-agent-icon"
    @click.stop
  >
    <wui-icon
      v-for="view in views"
      :key="`${view.icon}-${view.text}`"
      :name="view.icon"
      :title="view.text"
    />
  </div>
</template>

<script setup lang="ts">
import { WuiIcon } from '@wui/common-library'
import { computed } from 'vue'

import { useLocalization } from '@/shared/composables/localization'
import { getUserAgentView } from '@/shared/utils/platform'

const props = withDefaults(defineProps<{
  userAgent?: string | string[] | null
}>(), {
  userAgent: null,
})

const { t } = useLocalization()

const views = computed(() => {
  const agents = (Array.isArray(props.userAgent) ? props.userAgent : [props.userAgent])
    .filter((agent): agent is string => Boolean(agent))
  const unique = [...new Set(agents.map(agent => agent.toLocaleLowerCase()))]

  return unique.flatMap(agent => {
    const view = getUserAgentView(agent)
    if (!view) {
      return []
    }

    return [{
      icon: view.icon,
      text: t(view.textKey),
    }]
  })
})
</script>
